// extracted by mini-css-extract-plugin
export default {"floating":"sticky_floating__wP0T1","bottom":"sticky_bottom__RoQFN","top":"sticky_top__I2keT","transparent":"sticky_transparent__OPNvr","static":"sticky_static__2PUu8"};